import Image from "next/image";
import { Media_Assets } from "@/lib/sovereign-core/media";

type Logo_Mark_Props = {
  ClassName?: string;
  Alt_Text?: string;
};

export function Logo_Mark({
  ClassName = "h-10 w-10",
  Alt_Text = "Parcel Q logo",
}: Logo_Mark_Props) {
  return (
    <Image
      src={Media_Assets.Logo}
      alt={Alt_Text}
      width={256}
      height={256}
      className={`object-contain ${ClassName}`}
      priority
      suppressHydrationWarning
    />
  );
}
